import { useCallback, useMemo } from 'react';

import './index.css';
import InputField from '../../../../../components/Form/InputField';
import Checkbox from '../../../../../components/Checkbox';

interface Props {
  cbrt: string;
  setCbrt: (cbrt: string) => void;
  shorterTimeFrameInterval: string;
  setShorterTimeFrameInterval: (shorterTimeFrameInterval: string) => void;
  setShouldFetch: (value: boolean) => void;
  supportCbrtRange: boolean;
  setSupportCbrtRange: (supportCbrtRange: boolean) => void;
  supportMrcState: boolean;
  setSupportMrcState: (supportMrcState: boolean) => void;
  latestOrder: string;
  setLatestOrder: (latestOrder: string) => void;
  useTakeProfitTransactions: boolean;
  setUseTakeProfitTransactions: (supportCbrtRange: boolean) => void;
}

const CandlesForm = (props: Props) => {
  const {
    cbrt,
    setCbrt,
    shorterTimeFrameInterval,
    setShorterTimeFrameInterval,
    latestOrder,
    setLatestOrder,
    setShouldFetch,
    supportCbrtRange,
    setSupportCbrtRange,
    supportMrcState,
    setSupportMrcState,
    useTakeProfitTransactions,
    setUseTakeProfitTransactions,
  } = props;

  const handleCbrtChange = useCallback(
    (cbrt: string) => {
      setShouldFetch(false);
      setCbrt(cbrt);
    },
    [setCbrt, setShouldFetch],
  );

  const handleShorterTimeFrameInterval = useCallback(
    (quoteAsset: string) => {
      setShouldFetch(false);
      setShorterTimeFrameInterval(quoteAsset);
    },
    [setShorterTimeFrameInterval, setShouldFetch],
  );

  const handleLatestOrderChange = useCallback(
    (latestOrder: string) => {
      setShouldFetch(false);
      setLatestOrder(latestOrder);
    },
    [setLatestOrder, setShouldFetch],
  );

  const baseAssetField = useMemo(() => {
    return {
      label: 'Cbrt',
      value: cbrt,
      handleValueChange: handleCbrtChange,
      shouldFit: true,
    };
  }, [cbrt, handleCbrtChange]);

  const quoteAssetField = useMemo(() => {
    return {
      label: 'Shorter TimeFrame Interval',
      value: shorterTimeFrameInterval,
      handleValueChange: handleShorterTimeFrameInterval,
      shouldFit: true,
    };
  }, [handleShorterTimeFrameInterval, shorterTimeFrameInterval]);

  const latestOrderField = useMemo(() => {
    return {
      label: 'Latest Order',
      value: latestOrder,
      handleValueChange: handleLatestOrderChange,
      shouldFit: true,
    };
  }, [handleLatestOrderChange, latestOrder]);

  return (
    <div className="complexParams-form">
      <div className="candles-form-row" style={{ marginBottom: 40 }}>
        <div className="candles-form-item">
          <InputField config={baseAssetField} />
        </div>
        <div className="candles-form-item">
          <InputField config={quoteAssetField} />
        </div>
        <Checkbox
          label="Support Cbrt Range"
          value={supportCbrtRange}
          handleValueChange={setSupportCbrtRange}
        />
        <span className="complex-params-item">
          <Checkbox
            label="Support Mrc Range"
            value={supportMrcState}
            handleValueChange={setSupportMrcState}
          />
        </span>
      </div>

      <div className="candles-form-row">
        <div className="candles-form-item">
          <InputField config={latestOrderField} />
        </div>
        <span className="complex-params-item">
          <Checkbox
            label="Use Take Profit Transactions"
            value={useTakeProfitTransactions}
            handleValueChange={setUseTakeProfitTransactions}
          />
        </span>
      </div>
    </div>
  );
};

export default CandlesForm;
